(function ($) {

    var _original = $.fn.popover.Constructor.prototype.hide;

    $.extend($.fn.popover.Constructor.prototype, {
        hide: function (_relatedTarget) {

            var result =_original.call(this, _relatedTarget);

            this.inState = { click: false, hover: false, focus: false };

            return result;

        }
    });

})(jQuery);
